'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function head(arr) {
    return arr[0];
}

exports.head = head;
